export default __webpack_public_path__ + "static/media/user2.28a50129.png";